import React from "react";
import { Text, View } from "@react-pdf/renderer";

const ProluxCoils = ({ coilsCalc, heater }) => {
  return (
    <View
      wrap={false}
      style={{
        border: "2px solid black",
        fontSize: "8px",
        marginTop: "10px",
        paddingHorizontal: "5px",
        // pageBreakAfter: "always",
        // pageIbreakInside: "avoid",
        pageBreakBefore: "always",
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          borderBottom: "1px solid black",
        }}
      >
        <View style={{ width: "70%" }}>
          <Text style={{ fontSize: "10px", fontWeight: "600" }}>
            {heater ? "Lufterhitzerteil" : "Luftkühler KW"}
          </Text>
        </View>
      </View>

      <View style={{ display: "flex", flexDirection: "row" }}>
        <View style={{ width: "2%" }}>
          <Text>1</Text>
        </View>
        <View
          style={{
            width: "96%",
            borderLeft: "1px solid black",
            borderRight: "1px solid black",
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              textAlign: "center",
            }}
          >
            <View
              style={{
                paddingLeft: "2px",
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Lufterhitzer Fabrikat</Text>
              <Text>Prolux</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Medium</Text>
              <Text>PWW</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Material Rohre/ Lamellen</Text>
              <Text>Cu/Al</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Lamellen Absand</Text>
              <Text>2.5 mm</Text>
            </View>
            <View
              style={{
                // borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Rohrreihenzahl</Text>
              <Text>2</Text>
            </View>
          </View>

          <View
            //OVDE!!!!!!!!!!!!!!!!!!!!!!!!!!!!! do 2 viewa ispod dvojke
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              textAlign: "center",
              borderTop: "1px solid black",
            }}
          >
            <View
              style={{
                paddingLeft: "2px",
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Luftvolumenstrom</Text>
              <Text>{coilsCalc.volumeFlow} m³/h </Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Temperatur Eintritt</Text>
              <Text>{coilsCalc.temperatureIn} °C</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Feuchtigkeit Eintritt</Text>
              <Text>{coilsCalc.relativeHumidityIn} %</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Teperatur Austritt</Text>
              <Text>{coilsCalc.temperatureOut} °C</Text>
            </View>
            <View
              style={{
                // borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Feuchtigkeit Austritt</Text>
              <Text>{coilsCalc.relativeHumidityOut} %</Text>
            </View>
          </View>

          <View
            //OVDE!!!!!!!!!!!!!!!!!!!!!!!!!!!!! do 2 viewa ispod dvojke
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              textAlign: "center",
              borderTop: "1px solid black",
            }}
          >
            <View
              style={{
                paddingLeft: "2px",
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Medium Vorlauf</Text>
              <Text>{coilsCalc.mediumTemperatureIn} °C</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Medium Rücklauf</Text>
              <Text>{coilsCalc.mediumTemperatureOut} °C</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Medium Volumenstrom</Text>
              <Text>{coilsCalc.fluidFlow} m³/h</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Medium Druckverlust</Text>
              <Text>{coilsCalc.fluidPressureDrop} m/s</Text>
            </View>
            <View
              style={{
                // borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Leistung Normalbetrieb</Text>
              <Text>/</Text>
            </View>
          </View>

          <View
            //OVDE!!!!!!!!!!!!!!!!!!!!!!!!!!!!! do 2 viewa ispod dvojke
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              textAlign: "center",
              borderTop: "1px solid black",
            }}
          >
            <View
              style={{
                paddingLeft: "2px",
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Medium Nenndruck</Text>
              <Text>/</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Anschlüsse</Text>
              <Text>/</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "40%",
              }}
            >
              <Text>Medium Inhalt</Text>
              <Text>{coilsCalc.mediumType}</Text>
            </View>

            <View
              style={{
                // borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Leistung Abtaubetrieb</Text>
              <Text>/</Text>
            </View>
          </View>

          <View
            style={{
              paddingLeft: "2px",
              borderTop: "1px solid black",
              height: "30px",
            }}
          >
            <Text style={{ fontWeight: "600", fontSize: "10px" }}>
              Bemerkungen:
            </Text>
            <Text>Die Hydraulischen Daten entsprechen dem Abtaubetrieb</Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default ProluxCoils;
